<template>
  <div
    v-if="uploaderRecList.length"
    class="vrResult blogger-scroll"
  >
    <h3 class="fz-title">
      相关up主
    </h3>
    <div class="box-scrollbar negative component_izhbdC0qdn">
      <div class="scroll-layout scroll-layout-alone">
        <div class="item-list">
          <a
            v-for="(uploader, i) in uploaderRecList"
            :key="'uploader' + i"
            :href="uploaderRecUrl(uploader.author_id)"
            class="item-text"
          >
            <i class="img-height">
              <img :src="uploader.avatar_url">
              <span class="v-tag" />
            </i>
            <h4 class="item-title">{{ uploader.author }}</h4>
            <time class="item-time ellipsis">{{ uploader.fans_num }}粉丝</time>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('uploader', ['itemData']),
    uploaderRecList() {
      return (this.itemData && this.itemData.uploaderDesData && this.itemData.uploaderDesData.uploaderRecList) || [];
    },
  },
  methods: {
    uploaderRecUrl(id) {
      if (!id) {
        return 'javascript:void(0);';
      }
      const { spver } = this.$route.query;
      return `/uploader?key=${id}${spver === '1' ? '&spver=1' : ''}`;
    },
  },
};
</script>
